// extracted by mini-css-extract-plugin
export default {"gads":"ad_gads__rbO0+"};